<template>
	<ProcessCreatePage>
		<Header :title="title" v-if="!isRentalCarContractLater">
			<p>
				{{ $t('need_field_sign') }} <strong>{{ $t('customer_consultant') }}</strong>
				{{ $t('repair_shop_sign_customer_consultant', { repairShopType: repairShopLabel }) }}
			</p>
		</Header>
		<Header :title="title" v-if="isRentalCarContractLater">
			<p>
				{{ $t('need_field_sign') }} <strong>{{ $t('customer_consultant') }}</strong>
				{{ $t('rental_car_sign_customer_consultant', { repairShopType: repairShopLabel }) }}
			</p>
		</Header>

		<div class="main flex justify-around">
			<BaseSign v-if="isShown" v-model="sign" />
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import BaseSign from '../../forms/inputs/BaseSign';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'SignCustomerService',
	components: { ProcessCreatePage, BaseSign, Footer, Header },
	data() {
		return {
			sign: null,
			pdfURL: '',
		};
	},
	props: {
		isShown: { type: Boolean, default: false },
		isRentalCarContractLater: { type: Boolean, default: false },
		title: {
			default: function() {
				return this.$t('generate_form_sign_customer_consultant');
			},
		},
	},
	computed: {
		repairShopLabel() {
			if (this.$store.getters.getUser.usergroup?.level === 6) {
				return 'den Reparaturbetrieb';
			} else if (this.$store.getters.getUser.usergroup?.level === 5) {
				return 'das Autohaus';
			} else {
				return 'das Autohaus / den Reparaturbetrieb';
			}
		},
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next', null);
			} else if (this.sign) {
				this.$emit('next', { customerServiceSign: this.sign });
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('sign_process').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
